import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import moment from "moment"
import Encoding from "encoding-japanese"
import {NotificationSummary, TokenSummery} from "@/interface"
import API from "@/api"
import {vxm} from "@/store"

@Module({namespacedPath: "report/"})
export default class SiteModule extends VuexModule {

  // region token

  @getter
  public token_summaries: TokenSummery[] = []

  @mutation
  setTokenSummaries(token_summaries: TokenSummery[]) {
    this.token_summaries = token_summaries
    this.token_summaries.splice(0, 0)
  }

  @action()
  async fetchTokenSummaries(force: boolean = false) {
    if (this.token_summaries.length === 0 || force) {
      const token_summaries = await API.getTokenSummaries(vxm.app.selected_site_id)
      this.setTokenSummaries(token_summaries)
    }
  }

  // endregion

  // region notification

  @getter
  public notification_summaries: NotificationSummary[] = []

  @mutation
  setNotificationSummaries(notifications: NotificationSummary[]) {
    this.notification_summaries = notifications
  }

  @action()
  async fetchNotificationSummaries(payload: {
    force?: boolean,
    start_at?: number,
    end_at?: number,
    sort?: string,
    sort_direct?: string
  }) {
    if (this.notification_summaries.length === 0 || payload.force === true) {
      const notifications = await API.getNotificationSummaries({
        site_id    : vxm.app.selected_site_id,
        start_at   : payload.start_at,
        end_at     : payload.end_at,
        sort       : payload.sort,
        sort_direct: payload.sort_direct
      })

      this.setNotificationSummaries(notifications)
    }
  }

  @action()
  async getDownloadData(SPLITTER = ",", with_quote = true): Promise<Blob> {

    const quote = (str: string) => {
      if (!with_quote) return str
      const quoter = str.indexOf("\"") !== -1 ? "\"\"\"" : "\""
      return quoter + str + quoter
    }

    const CRLF = "\r\n"
    const header = ["Date", "Title", "Sent", "Show", "Click", "CTR"]

    const data =
            header.map(item => quote(item)).join(SPLITTER) + CRLF
            +
            this.notification_summaries
              .map((item) => {
                const d = moment(item.reserve_at)
                return [
                  (d.isValid() ? d.format("YYYY-MM-DD HH:mm") : ""),
                  item.title,
                  item.send_count?.toString() || "",
                  item.distribute_count?.toString() || "",
                  item.open_count?.toString() || "",
                  item.ctr?.toString() || ""
                ]
              })
              .map(item => item.map(cell => quote(cell)))
              .map(item => item.join(SPLITTER))
              .join(CRLF)

    const unicodeList = []
    for (let i = 0; i < data.length; i += 1) {
      unicodeList.push(data.charCodeAt(i))
    }

    const shiftJisCodeList = Encoding.convert(unicodeList, "SJIS", "UNICODE")
    const uInt8List = new Uint8Array(shiftJisCodeList)

    return new Blob([uInt8List], {type: "text/csv"})

  }

  // endregion
}